export default [
  {
    text: 'Platform',
    value: 'country',
    width: '24%',
    sort: (a, b) => {
      const codeA = (a?.code ?? a ?? '').toString().toUpperCase();
      const codeB = (b?.code ?? b ?? '').toString().toUpperCase();
      return codeA.localeCompare(codeB);
    },
  },
  {
    text: 'Publisher ID',
    value: 'publisher_id',
    width: '24%',
  },
  {
    text: 'API token',
    value: 'auth_token',
  },
  {
    text: ' ',
    value: 'actions',
    action: 'delete',
    icon: 'delete',
    width: '80px',
    sortable: false,
  },
];
